import PropTypes from "prop-types";
import { useRef, useState } from "react";

import styled from "styled-components/macro";
import { borderRadius, center, color, shadow } from "theme";

import FnrCard from "UI/FnrCard/FnrCard";
import FnrChevron from "UI/FnrChevron/FnrChevron";
import FnrIcon from "UI/FnrIcon/FnrIcon";
import FnrIconGrid from "UI/FnrIconGrid/FnrIconGrid";
import { FnrPopover } from "UI/FnrPopover2";
import FnrHorizontalGap from "UI/commonContainers/FnrHorizontalGap/FnrHorizontalGap";

const SFnrCard = styled(FnrCard)`
  display: inline-flex;
  font-size: 26px;
  min-width: 60px;
`;

const PopoverContents = styled("div")`
  width: 245px;
  overflow: auto;
  min-height: 40px;
  max-height: 320px;
  background-color: ${({
    theme: {
      colors: { white },
    },
  }) => white};
  ${borderRadius}
  ${shadow}
`;

const SDiv = styled("div")`
  ${color}
  ${center}
`;

const FnrIconSelect = ({
  selected = "",
  onSelect = () => {},
  disabled,
  showEmptyOption = false,
  ...rest
}) => {
  const [showPopover, setShowPopover] = useState(false);
  const ref = useRef();

  const togglePopover = () => {
    setShowPopover(!showPopover);
  };

  const closePopover = () => {
    setShowPopover(false);
  };

  const handleSelect = (selectedIcon) => {
    onSelect(selectedIcon);
    setShowPopover(false);
  };

  return (
    <>
      <SFnrCard
        ref={ref}
        onClick={togglePopover}
        data-cy="IconSelect_Container"
        noGradient
        variant="input"
        disabled={disabled}
        {...rest}
      >
        <FnrHorizontalGap fullWidth>
          <SDiv
            $variant={disabled ? "disabled" : undefined}
            data-cy="IconSelect_IconContainer"
          >
            <FnrIcon icon={selected} center />
          </SDiv>
          <FnrChevron
            active={showPopover}
            disabled={disabled}
            data-cy="IconSelect_Chevron"
          />
        </FnrHorizontalGap>
      </SFnrCard>

      <FnrPopover
        buttonRef={ref}
        show={showPopover}
        onShouldClose={closePopover}
        onClose={closePopover}
        color="white"
      >
        <PopoverContents
          $variant="selectList"
          data-cy="IconSelect_PopoverContents"
        >
          <FnrIconGrid
            selected={selected}
            onSelect={handleSelect}
            showEmptyOption={showEmptyOption}
          />
        </PopoverContents>
      </FnrPopover>
    </>
  );
};

FnrIconSelect.propTypes = {
  selected: PropTypes.string,
  onSelect: PropTypes.func,
  disabled: PropTypes.bool,
  showEmptyOption: PropTypes.bool,
};

export default FnrIconSelect;
